import React from 'react';

import { Text } from '@change/ds-core-ui';

import { translationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { useEasyBrief } from './hooks/useEasyBrief';

export const EasyBrief: React.FC<EmptyProps> = () => {
	const {
		data: { briefs },
	} = useEasyBrief();

	return (
		<div className="container pt-4 pb-15 md:pt-14 md:pb-12">
			<div className="px-2 md:px-14">
				<Text as="h2" variant="heading" className="text-typography-strong text-left md:text-center">
					<TypedTranslate value={translationKey('corgi.homepage.how_to_sunrise.easy_brief.title')} />
				</Text>

				<div className="mt-7 flex flex-col gap-8 md:mt-10 md:flex-row md:items-start md:gap-0">
					{briefs.map((brief, index) => (
						<React.Fragment key={brief.key}>
							<div className="relative flex flex-row items-start gap-5 md:flex-1 md:flex-col md:items-center md:gap-4 md:px-4">
								{/* Desktop horizontal connector */}
								{index !== briefs.length - 1 && (
									<div className="border-stroke-info-weak/50 absolute top-9 left-1/2 hidden w-[calc(100%-36px)] translate-x-9 border-t-[1.5px] md:block" />
								)}

								{/* Mobile vertical connector: anchored to this circle's bottom (top-12)
								    and the next circle's top (-bottom-8 spans the gap-8 between steps),
								    so it stays connected regardless of how many lines the text wraps to */}
								{index !== briefs.length - 1 && (
									<div className="bg-stroke-info-weak/50 absolute top-12 -bottom-8 left-6 w-[1.5px] -translate-x-1/2 md:hidden" />
								)}

								{/* Step circle */}
								<div className="border-stroke-info-weak/50 bg-fill-information-weaker relative z-10 grid h-12 w-12 shrink-0 place-items-center rounded-full border-[1.5px] md:h-[72px] md:w-[72px]">
									<Text
										variant="body"
										fontWeight="bold"
										size="small"
										className="text-typography-information md:text-size-body-large-bold"
									>
										{index + 1}
									</Text>
								</div>

								{/* Step text */}
								<div className="flex flex-1 flex-col gap-0.5 md:flex-none md:items-center md:gap-2">
									<Text
										as="div"
										fontWeight="bold"
										variant="body"
										size="medium"
										className="text-typography-strong md:text-size-body-large-bold md:text-center"
									>
										<TypedTranslate value={brief.titleKey} />
									</Text>
									<Text variant="body" size="small" className="text-typography-weak md:text-center">
										<TypedTranslate value={brief.descriptionKey} />
									</Text>
								</div>
							</div>
						</React.Fragment>
					))}
				</div>
			</div>
		</div>
	);
};
